import { render, staticRenderFns } from "./NoticeLawyerParty.vue?vue&type=template&id=23aeec30"
import script from "./NoticeLawyerParty.vue?vue&type=script&lang=ts"
export * from "./NoticeLawyerParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports